import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import OnePicture from '../OnePicture';
import NewRefine from '../NewRefine';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { TimelineMax, TweenMax } from 'gsap';
import { useEffect, useState } from 'react';
import { config as coreAnimationConfig } from './conf';
import OnePictureClassic from 'elem/compPage/delta-3-classic-portable-power-station/pages/product/components/OnePicture/index.tsx';

interface CoreAnimationProps {
    pageType: 'max' | 'ultra' | 'classic';
}

const CoreAnimation: React.FC<CoreAnimationProps> = ({ pageType } = { pageType: 'max' }) => {
    const { locale } = getLocal();
    const { t } = useLang('CoreAnimation');

    const [isMobile, setIsMobile] = useState(true);

    const [currentFrame, setCurrentFrame] = useState(0);
    if (typeof window !== 'undefined') {
        if (!window?.ScrollMagic) {
            window.ScrollMagic = ScrollMagicFn();
            ScrollMagicPluginGsap(window.ScrollMagic, TweenMax, TimelineMax);
        }
    }

    const config = coreAnimationConfig[pageType];

    useEffect(() => {
        if (isMobile) {
            return;
        }
        const scene = new ScrollMagic.Scene({
            triggerElement: '#core-animation',
            triggerHook: 0.5,
            // offset: window.innerHeight * 0.5,
            duration: (160 + window.innerHeight) / 0.3,
        });

        const controller = new ScrollMagic.Controller();

        const timeline = new TimelineMax({});

        const windowWidth = document.documentElement.clientWidth;

        const padding = Math.max(120, (windowWidth - 1200) / 2);
        // 创建多个动画，每个动画1秒duration
        const item1Anim = TweenMax.fromTo(
            '#NewRefine .item-1',
            0.05,
            {
                // x: -padding,
                // x: 0,
                // y: -(160 + window.innerHeight),
                // scale: 1,
                // width: window.innerWidth,
                // height: window.innerHeight,
                opacity: 0.3,
                ease: 'linear',
            },
            {
                // x: 0,
                // y: -(160 + window.innerHeight),
                // width: window.innerWidth,

                // scale: 1200 / 1920,
                // width: windowWidth - padding * 2,
                // height: 400,

                opacity: 1,
                ease: 'linear',
            },
        );

        const item2Anim = TweenMax.fromTo(
            '#NewRefine .item-1',
            0.3,
            {
                // x: -padding,
                // x: 0,
                // y: -(160 + window.innerHeight),
                // scale: 1,
                width: window.innerWidth,
                height: window.innerHeight,
                // opacity: 0.3,
                ease: 'linear',
            },
            {
                // x: 0,
                // y: -(160 + window.innerHeight),
                // width: window.innerWidth,

                // scale: 1200 / 1920,
                width: windowWidth - padding * 2,
                height: 400,

                // opacity: 1,
                ease: 'linear',
            },
        );

        const CanvasAnim = TweenMax.fromTo(
            '#core-animation .canvas',
            0.05,
            {
                opacity: 1,
                // x: 0,
            },
            {
                // opacity: 0.8,
                // scale: 0.4,
                // x: window.innerWidth * 0.01,
                // y: 0,
                opacity: 0,
                ease: 'linear',
            },
        );

        const itemTextWrapper = TweenMax.fromTo(
            '#NewRefine .item-wrapper .item1-text-wrapper',
            0.05,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                ease: 'linear',
            },
        );
        const arrowWrapper = TweenMax.fromTo(
            '#NewRefine .item-wrapper .arrow',
            0.05,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                ease: 'linear',
            },
        );

        // const canvasAnim2 = TweenMax.fromTo(
        //     '#core-animation .canvas',
        //     0.01,
        //     {
        //         opacity: 1,
        //     },
        //     {
        //         opacity: 0,
        //         ease: 'linear',
        //     },
        // );

        const textOutAnim = TweenMax.fromTo(
            '#core-animation .container-wrapper .text-wrapper',
            0.05,
            {
                opacity: 1,
            },
            {
                opacity: 0,
                ease: 'linear',
            },
        );
        const textInAnim = TweenMax.fromTo(
            '#core-animation .container-wrapper .text-wrapper',
            0.05,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                ease: 'linear',
            },
        );

        // const item2Anim = TweenMax.from('#OnePicture .item-2', 1, { x: -200, opacity: 0 });
        // const item3Anim = TweenMax.from('#OnePicture .item-3', 1, { y: 200, opacity: 0 });

        // 精确控制动画时机 - 确保在70%进度时开始
        // 1. 首先设置时间轴的总时长为1秒
        const totalDuration = 1;

        // 2. 根据进度计算每个动画的开始时间
        const textInStartTime = 0.005 * totalDuration; // 2%进度时开始
        const textOutStartTime = 0.07 * totalDuration; // 15%进度时开始
        const canvasAnimStartTime = 0.65 * totalDuration; // 70%进度时开始  执行时长0.1
        // const canvasAnim2StartTime = 0.8 * totalDuration; // 71%进度时开始  执行时长0.1
        const item1AnimStartTime = 0.65 * totalDuration; // 75%进度时开始
        const item2AnimStartTime = 0.7 * totalDuration; // 70%进度时开始
        const itemTextWrapperStartTime = 0.8 * totalDuration; // 75%进度时开始
        const arrowWrapperStartTime = 0.8 * totalDuration; // 75%进度时开始

        // 3. 添加动画到时间轴
        // timeline.add(textInAnim, textInStartTime);
        timeline.add(textOutAnim, textOutStartTime);
        timeline.add(item1Anim, item1AnimStartTime);
        timeline.add(CanvasAnim, canvasAnimStartTime);
        // timeline.add(canvasAnim2, canvasAnim2StartTime);
        timeline.add(item2Anim, item2AnimStartTime);
        timeline.add(itemTextWrapper, itemTextWrapperStartTime);
        timeline.add(arrowWrapper, arrowWrapperStartTime);

        // 4. 明确设置时间轴的总时长
        timeline.duration(totalDuration);

        // 5. 调试信息 - 验证时间轴设置
        console.log('Timeline total duration:', timeline.duration());
        console.log('Main animation start time:', item1AnimStartTime);
        console.log('Expected progress for main animation:', item1AnimStartTime / timeline.duration());

        // timeline.add(item1MoveAnim, 0.8);
        // .add(item2Anim, 0.2) // 滚动20%时开始，与item1重叠
        // .add(item3Anim, 0.4); // 滚动40%时开始

        const itemWrapper = document.querySelector('#NewRefine .item-wrapper');
        scene
            .setTween(timeline)
            .on('start', () => {
                console.log('start');
            })
            .on('progress', (e: { progress: number }) => {
                // console.log(e.progress, 'progress');
                if (e.progress > 0.7) {
                    if (itemWrapper) {
                        (itemWrapper as HTMLElement).style.zIndex = '1';
                    }
                    return;
                }

                (itemWrapper as HTMLElement).style.zIndex = '-1';
                const frameProgress = e.progress / 0.7;
                const frameNumber = Math.max(1, Math.min(config.totalFrames, Math.ceil(frameProgress * config.totalFrames)));
                if (frameNumber !== currentFrame) {
                    setCurrentFrame(frameNumber);
                }
            });
        controller.addScene(scene);
        return () => {
            controller.destroy();
        };
    }, [isMobile]);

    useEffect(() => {
        setIsMobile(window.innerWidth < 1024);
    }, []);

    console.log('pageType', pageType);

    return (
        <div
            className={`${styles.CoreAnimation} ` + `core-animation-${pageType}`}
            id="core-animation"
            style={{ backgroundColor: pageType === 'classic' ? '#f3f0e8' : '#1a1a1a' }}
        >
            {<NewRefine currentFrame={currentFrame} pageType={pageType} />}
            {pageType === 'classic' && <OnePictureClassic />}
            {pageType !== 'classic' && <OnePicture pageType={pageType} />}
        </div>
    );
};

export default CoreAnimation;
